import { getWithDefault } from "@chakra-ui/utils";
export function createStyleFunction(config) {
  var {
    property,
    scale,
    transform = getWithDefault,
    defaultScale
  } = config;
  var properties = config.properties || [property];
  var styleFunction = (value, scale, props) => {
    var result = {};
    var rawValue = transform(value, scale, props);
    if (rawValue === null) return;
    properties.forEach(prop => {
      result[prop] = rawValue;
    });
    return result;
  };
  styleFunction.scale = scale;
  styleFunction.defaults = defaultScale;
  return styleFunction;
}